import { useMerchantEmployees } from "Api/Queries/Merchants/Employees/useMerchantEmployees";
import { FilterDropdown } from "Components/Shared/Components/FilterDropdown";
import type { FilterOption } from "Components/Shared/Filters/FilterOption";
import { Resources, useResource } from "Translations/Resources";

const PageResources = Resources.Components.Shared.Filters;

type Props = {
  value: FilterOption | undefined;
  onChange: (option: FilterOption | undefined) => void;
};

export const EmployeeFilterDropdown = ({ value, onChange }: Props) => {
  const { t } = useResource();

  const { data: employeesData, isLoading } = useMerchantEmployees(undefined, {
    limit: 100,
  });

  const options = [
    { value: "", label: t(PageResources.AllEmployees) },
    ...(employeesData?.items?.map(
      ({ firstName, lastName, email, publicID }) => ({
        value: publicID ?? "",
        label:
          firstName && lastName
            ? `${firstName} ${lastName}`
            : (email ?? publicID ?? ""),
      }),
    ) ?? []),
  ];

  const handleChange = (newValue: string | number) => {
    const selectedPublicID = newValue as string;
    if (!selectedPublicID) {
      onChange(undefined);
      return;
    }
    const { label = "" } =
      options.find(({ value }) => value === selectedPublicID) ?? {};

    onChange({ publicID: selectedPublicID, label });
  };

  return (
    <FilterDropdown
      label={t(PageResources.Employee)}
      options={options}
      value={isLoading ? "" : (value?.publicID ?? "")}
      onChange={handleChange}
      disabled={isLoading}
      placeholder={t(PageResources.AllEmployees)}
    />
  );
};
